import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { ResetPassResponse } from '@app/utils/interfaces/passReset.interface';
import { VerifyTokenBody } from '@app/utils/interfaces/passwordData.interface';
import { environment } from '@env/environment';
import { filter, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VerifyTokenService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  verifyToken(data: VerifyTokenBody): Observable<ResetPassResponse> {
    return this.http
      .post<ResetPassResponse>(`${this.baseUrl}${ApiEndpoints.VERIFY_RESET_TOKEN}`, data)
      .pipe(filter((data) => Boolean(data)));
  }
}
